import type { AppEnv } from './environment.default';
import { ENVIRONMENT, environment as defaultEnv } from './environment.default';

export const environment: AppEnv = {
  ...defaultEnv,
  ENV: ENVIRONMENT.development,
  AUTH_CLIENT_ID: 'c451c2b2-2ffa-4b55-af8b-6e283cb9d6d5',
  DEBUG_AUTH_FLOW: true,
  DEBUG_PLATFORM: true,
  DEBUG_MOCK_SOFTWARE_DOWNLOADS: true,
};
